<template>
  <div>
    <h1
      class="Tit Tit--login"
      v-t="{path : 'login_change_passcode_form_submit'}"
    ></h1>
    <i18n
      tag="span"
      class="Fuell-Text"
      path="login_change_passcode_form_information"
    >
      <template v-slot:userName>
        <span class="text-primary"> {{loggedUserName}} </span>
      </template>
    </i18n>
    <div class="d-flex flex-column justify-content-between mt-3">
      <template v-if="changePasscodeStep === 1">
        <span
          class="Fuell-Text"
          v-t="{path: 'user_profile_change_passcode_step_two'}"
        ></span>
        <div class="passcode-container">
          <passcode-picker
            key="newPascode"
            @complete="setNewPasscode"
          />

        </div>
      </template>
      <template v-if="changePasscodeStep === 2">
        <span
          class="Fuell-Text"
          v-t="{path: 'user_profile_change_passcode_step_three'}"
        ></span>
        <div class="passcode-container d-flex justify-content-center">
          <passcode-picker
            v-if="!isChangingPasscode"
            key="confirmNewPasscode"
            @complete="confirmNewPasscode"
          />
          <template v-else>
            <div class="d-flex flex-column justify-content-center my-2">
              <spinner class="mx-auto" />
              <small> Enviando...</small>

            </div>
          </template>

        </div>
      </template>
      <template v-if="changePasscodeStep === 3">
        <h3
          class="Fuell-Modal--title"
          v-t.preserve="{path: 'user_profile_change_passcode_success'}"
        ></h3>

        <div class="flex center">
          <img
            alt="icon-check"
            :src="require('@/assets/img/icons/big-check-green.svg')"
            class="my-5"
          >
        </div>
      </template>
      <small
        class="text-danger mb-3"
        v-t="{path:'user_profile_change_passcode_passcode_mismatch'}"
        v-if="newPasscodeMismatchFlag"
      ></small>
    </div>

  </div>
</template>

<script>
import PasscodePicker from '@/modules/users/_components/_shared/PasscodePicker'
import Spinner from '@/components/Commons/Spinner'
export default {
  name: 'ResetPasscodeForm',
  components: { PasscodePicker, Spinner },
  data () {
    return {
      newPasscode: '',
      repeatNewPasscode: '',
      changePasscodeStep: 1,
      newPasscodeMismatchFlag: false,
      showSuccessFlag: false,
      isChangingPasscode: false
    }
  },
  computed: {
    loggedUser () {
      return this.$store.getters['LoginStore/user'] || false
    },
    loggedUserName () {
      return this.loggedUser && this.loggedUser.firstName ? this.loggedUser.firstName : ''
    },
    disableSubmitChangePasscodeButton () {
      return this.isChangingPasscode || this.repeatNewPasscode.length === 0
    }
  },
  methods: {
    goToDashboard () {
      this.$router.push({ name: 'dashboard' })
    },
    setNewPasscode (event) {
      this.newPasscode = event
      this.changePasscodeStep = 2
    },
    confirmNewPasscode (event) {
      this.repeatNewPasscode = event
      if (this.newPasscode !== this.repeatNewPasscode) {
        this.changePasscodeStep = 1
        this.newPasscode = ''
        this.repeatNewPasscode = ''
        this.newPasscodeMismatchFlag = true
      } else {
        this.newPasscodeMismatchFlag = false
        this.changePasscode()
      }
    },
    async changePasscode () {
      if (this.isChangingPasscode) return
      try {
        this.isChangingPasscode = true
        const tokenData = {
          token: this.$route.params.token,
          passcode: this.newPasscode
        }
        await this.$store.dispatch('UsersStore/resetPasscode', { userId: this.loggedUser.id, tokenData: tokenData })
        this.$store.dispatch('SnackBars/addSuccess', this.$t('login_change_passcode_success_with_redirect'), { root: true })
        this.isChangingPasscode = false
        this.changePasscodeStep = 3
        setTimeout(() => {
          this.$router.push({ name: 'dashboard' })
        }, 2000)
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'user_reset_passcode_error' }, { error: true })
        this.isChangingPasscode = false
        this.changePasscodeStep = 1
      }
    }
  }

}
</script>

<style scoped>
.passcode-container >>> .passcode-picker {
  margin: 25px 0px;
}
</style>
